import { useRouteLoadingStore } from '@shared/stores/routeLoading.js'
import { ref } from 'vue'

export default function useRouteLoading() {
  const loadingRequestId = ref(null)

  const { addLoadingRequest, removeLoadingRequest } = useRouteLoadingStore()

  function onLoadPending() {
    loadingRequestId.value = addLoadingRequest()
  }

  function onLoadResolve() {
    if (loadingRequestId.value) {
      removeLoadingRequest(loadingRequestId.value)
      loadingRequestId.value = null
    }
  }

  return {
    loadingRequestId,
    onLoadPending,
    onLoadResolve
  }
}
